<!-- PopupPage.vue -->
<template>
  <div>
    <DxPopup 
      :visible.sync="isVisible"
      :title="'DevExtreme Popup'"
      :width="popupWidth"
      :height="popupHeight"
      :show-title="true"
      :drag-enabled="true"
      :close-on-outside-click="true"
      :resize-enabled="true"
       @hidden="handleHidden"
    >

      <!-- devex form start from here -->
      <DxForm
          :formData="formData"
          :col-count="formColCount"
          :min-col-width="300"
        >
        <template v-for="(item, index) in formItems" :key="index">
          <DxSimpleItem 
            :dataField="item.dataField" 
            :editorType="item.editorType"
            :editorOptions="item.editorOptions"
             :label="{ text: item.label.text, location: item.label.location }"
          >
          </DxSimpleItem>
        </template>
        </DxForm>
      <!-- devex form end -->

      <DxToolbarItem
          toolbar="bottom"
          location="after"
          widget="dxButton"
          :options="clearButtonOptions"
        />
        <DxToolbarItem
          toolbar="bottom"
          location="after"
          widget="dxButton"
          :options="filterButtonOptions"
        />

    </DxPopup>
  </div>
</template>

<script>
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxForm, DxSimpleItem } from 'devextreme-vue/form';
// import formData from '@/Pages/formData.json';

export default {
  name: 'Popup',
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
 
  data() {
    return {
      // popupVisible: false,
      popupWidth: 600,
      popupHeight: 400,
      formColCount: 2,
     
      formItems: [
        {
          dataField: 'firstName',
          editorType: 'dxTextBox',
          label: {
            text: 'First Name',
            location: 'top'
          }
        },
        {
          dataField: 'lastName',
          editorType: 'dxTextBox',
          label: {
            text: 'Last Name',
            location: 'top'
          }
        },
        {
          dataField: 'email',
          editorType: 'dxTextBox',
          label: {
            text: 'Email',
            location: 'top'
          }
        },
        {
          dataField: 'phone',
          editorType: 'dxTextBox',
          label: {
            text: 'Phone',
            location: 'top'
          }
        },
        {
          dataField: 'address',
          editorType: 'dxTextBox',
          label: {
            text: 'Address',
            location: 'top'
          }
        }
      ],
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: ''
      },

      // buttons methods
      clearButtonOptions: {
        text: "Clear",
        onClick: this.clearAction,
        stylingMode: "outlined",
        type: "normal"
      },
      filterButtonOptions: {
        text: "Filter",
        onClick: this.filterAction,
        stylingMode: "contained",
        type: "default",  // Change this to 'success', 'primary', etc., if needed.
        elementAttr: { style: "background-color: #007bff; color: white;" } // Setting the primary color
      },
      onPopupHidden() {
      this.$emit('hidden');  // Emit hidden to parent to reset isVisible
    }

    }; 
  },
  methods: {
    handleHidden() {
      this.$emit('hidden');  // Emit the 'hidden' event to the parent
    },
    clearAction() {
      // Logic for the Clear button
      console.log("Clear button clicked");
    },
    filterAction() {
      // Logic for the Filter button
      console.log("Filter button clicked");
    }
  },
};
</script>

<style>
.dx-popup-title.dx-toolbar {
  padding: 5px 25px;
}
.dx-popup-content {
  padding: 10px 25px;
}
.dx-popup-bottom.dx-toolbar {
  padding: 10px 25px;
  overflow: visible;
}
</style>